


















/* eslint-disable @typescript-eslint/ban-ts-comment */
import config from "@/configs";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

export default Vue.extend({
  name: "CardPaymentInput",
  props: {
    paymentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      myPaymentElement: null,
      myStripe: null,
      myElements: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("paymentIntent", ["getPaymentIntents"]),
    ...mapGetters("customer", ["getSelectedCustomerId"]),
    payment(): any {
      return (
        this.getPaymentIntents.filter(
          (pi: any) => pi.id === this.paymentId
        )[0] || {}
      );
    },
  },
  mounted() {
    // Set your publishable key: remember to change this to your live publishable key in production
    // See your keys here: https://dashboard.stripe.com/apikeys
    const options = {
      clientSecret: this.payment.client_secret,
    };
    // @ts-ignore
    // eslint-disable-next-line no-undef
    const stripe = Stripe(config?.stripe?.pubKey || "", options);

    // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 3
    const elements = stripe.elements(options);

    // Create and mount the Payment Element
    const paymentElement = elements.create("payment");
    paymentElement.mount("#payment-element");

    this.myPaymentElement = paymentElement;
    this.myStripe = stripe;
    this.myElements = elements;
  },
  methods: {
    ...mapActions("customer", ["updateCustomer"]),
    async submit(): Promise<void> {
      this.loading = true;
      // @ts-ignore
      await this.myStripe
        .confirmPayment({
          //`Elements` instance that was used to create the Payment Element
          elements: this.myElements,
          confirmParams: {
            return_url: "https://nowhere.to.go.com",
          },
          redirect: "if_required",
        })
        .then((result: any) => {
          if (result.error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            const messageContainer: any =
              document.querySelector("#error-message");
            messageContainer.textContent = result.error.message;
          } else {
            // Set the new payment method as default for this user if config enable
            if (config?.settings?.setNewPaymentMethodAsDefault) {
              const payload = {
                id: this.getSelectedCustomerId,
                payload: {
                  invoice_settings: {
                    default_payment_method: result.paymentIntent.payment_method,
                  },
                },
              };
              this.updateCustomer(payload);
            }
            this.$emit("paymentSuccess");
          }
          this.loading = false;
        });
    },
  },
});
